import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AA336A"];
const TYPE_COLOR_MAP = {
  "Single Family": "#0088FE",  // Blue
  "Town House": "#00C49F",     // Green
  "Condo": "#888888",          // Gray
};
const BuildingTypeChart = ({ data }) => {
  

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { type, count, percentage } = payload[0].payload;
      return (
        <div className="bg-white p-2 border rounded shadow text-sm">
          <p><strong>{type}</strong></p>
          <p>Transactions: {count}</p>
          <p>Percentage: {percentage}%</p>
        </div>
      );
    }
    return null;
  };

  return (
    
    <div className="w-full max-w-md mt-6 ml-0">
      <div className="text-sm mt-1 space-y-1 mx-auto text-left" style={{ maxWidth: "220px" }}>
        {data.map((entry, index) => (
          <p
            key={index}
            className="font-bold"
            style={{ color: TYPE_COLOR_MAP[entry.type] || "#CCCCCC" }}
          >
            {`${entry.type}: ${entry.count} (${entry.percentage}%)`}
          </p>
        ))}
      </div>
      <ResponsiveContainer width="100%" height={320}>
        <PieChart>
          <Pie
            data={data}
            dataKey="percentage"
            nameKey="type"
            cx="50%"
            cy="50%"
            outerRadius="90%"
            labelLine={false}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={TYPE_COLOR_MAP[entry.type] || "#CCCCCC"}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend verticalAlign="bottom" height={50} />
        </PieChart>
      </ResponsiveContainer>

      {/* Summary labels below chart */}
    </div>
  );
};

export default BuildingTypeChart;
